import React from 'react';

interface UndoRedoControlsProps {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

export const UndoRedoControls: React.FC<UndoRedoControlsProps> = ({
  canUndo,
  canRedo,
  onUndo,
  onRedo
}) => {
  return (
    <div className="flex gap-2">
      <button
        onClick={onUndo}
        disabled={!canUndo}
        className={`h-8 px-3 flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors ${
          !canUndo ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        style={{
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
        }}
      >
        <svg
          width="17"
          height="17"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-500"
        >
          <path
            d="M3.5 7h5a3.5 3.5 0 0 1 3.5 3.5v0"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.5 4.5L3 7l2.5 2.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="text-sm text-gray-600">Undo</span>
      </button>
      <button
        onClick={onRedo}
        disabled={!canRedo}
        className={`h-8 px-3 flex items-center gap-1.5 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50 transition-colors ${
          !canRedo ? 'opacity-50 cursor-not-allowed' : ''
        }`}
        style={{
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
        }}
      >
        <svg
          width="17"
          height="17"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="text-gray-500"
        >
          <path
            d="M12.5 7h-5a3.5 3.5 0 0 0-3.5 3.5v0"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 4.5L13 7l-2.5 2.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="text-sm text-gray-600">Redo</span>
      </button>
    </div>
  );
}; 